import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

import { AvailableValidators } from '../validation-helpers/object-validation';

/** Mapping of the validator type to the validator */
const lookupSync = {
	required: Validators.required,
	min: Validators.min,
	max: Validators.max,
	minLength: Validators.minLength,
	maxLength: Validators.maxLength,
	email: Validators.email,
};

/**
 * Adds validators to form group, can use the vlaidations as provided in the model interface.
 * @param group
 * @param validations
 */
export function addValidatorsToFormGroup(
	group: FormGroup,
	validations: {
		[fieldName: string]: AvailableValidators;
	}
): void {
	const controls = group.controls;
	Object.keys(validations).forEach(updateGroup);

	function updateGroup(key: string) {
		if (!controls[key]) {
			throw new Error(
				`You can not add a validation on a non-existing control. ${key} does not exists in this formgroup ${Object.keys(controls)}`
			);
		}
		addValidatorsToFormControl(controls[key], validations[key]);
	}
}

/**
 * Add validators to form control
 * @param control
 * @param validations
 */
export function addValidatorsToFormControl(control: AbstractControl, validations: AvailableValidators) {
	const validators = [];
	for (const [validator, value] of Object.entries(validations)) {
		if (lookupSync[validator]) {
			const validatorFn = lookupSync[validator];
			if (value === true) {
				// only required will have true for it's value
				// also its the only validator that doesn't accept a parameter
				validators.push(validatorFn);
			} else {
				validators.push(validatorFn(value));
			}
			// go on with next validator
			continue;
		}

		// no validator is found, throw an error, as this is an programming mistake
		throw new Error(`Trying to use unknown validator:"${validator}"`);
	}
	if (validators.length > 0) {
		control.setValidators(validators);
	}
	// TODO?: this function will "overwrite" existing validators. Is that something we should take in account?
}
